import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12 mt-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Brand Section */}
          <div className="text-center">
            <h3 className="text-2xl font-display font-bold tracking-tight text-white">
              RX Amplify
            </h3>
            <p className="flex items-center justify-center gap-1.5 text-slate-300 text-sm mt-2">
              by
              <img
                src={`${process.env.PUBLIC_URL || ''}/akaike-logo.svg`}
                alt="Akaike"
                className="h-3.5 w-auto brightness-0 invert"
              />
            </p>
            <p className="text-gray-300 mt-2 text-sm">
              Empowering pharma teams with AI-driven insights
            </p>
          </div>

          {/* Divider */}
          <div className="w-48 h-px bg-gradient-to-r from-transparent via-blue-400 to-transparent"></div>

          {/* Footer Bottom */}
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} RX Amplify by Akaike
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
